.loadingStatus {
  visibility: hidden;
}

.loadingStatus[data-visible='true'] {
  visibility: visible;
}
